import ajax from './ajax'
const qs = require('querystring');

const BASE = process.env.NODE_ENV === 'production' ? '' : '/api';


const getImages = params => ajax(BASE +  `/owe/oweImageList?${qs.stringify({...params, pageSize: 100})}`);

const getContent = params => ajax(BASE + `/owe/imageContentList?${qs.stringify(params)}`);

const getOnlyContent = params => ajax(BASE + '/owe/oweContentList', params);

const getContentById = ({id, lang}) => ajax(BASE + `/owe/contentInfo/${id}/${lang}`);

const searchContent = params => ajax(BASE + '/owe/searchKeyWords', params)

const saveUserInfo = params => ajax(BASE + '/user/submitUserInfo', params, 'post');

const getSignature = params => ajax(BASE + '/user/wxShare', params);

let getClimateIndexInfo = params => ajax(BASE + '/owe/indexDetail', params);

let getClimateTrendList = params => ajax(BASE + '/owe/climateIndexByDate', params);

const getContentByPageOrder = params => ajax(BASE + '/owe/oweContentListPage', params);

// const ENV = process.env.NODE_ENV
// if(ENV  === "development"){

//   getClimateIndexInfo = params => ajax(BASE + '/owe/indexDetail', params).then(()=>{
//     return require('./climate_info_mock')
// });

//   getClimateTrendList = params => ajax(BASE + '/owe/climateIndexByDate', params).then(()=>{
//   return require('./climate_trend_mock')
// });
// }




export default {
  getImages, getContent, getContentById, searchContent, getOnlyContent, saveUserInfo, getSignature,
  getClimateIndexInfo,getClimateTrendList, getContentByPageOrder
}
